import React from "react";
import { useSelector } from "react-redux";
import withFetchOne from "../../../../hocs/withFetchOne";
import VehicleCategoryForm from "../components/form/VehicleCategoryForm";
import SettingHeader from "../components/header/SettingHeader";
import { doGetVehicleCategory } from "../store/VehicleCategoryThunks";
import { selectVehicleCategory } from "../store/VehicleCategorySlice";
import "../styles/settings.scss";
import { withPermission } from "hocs/withPermission";
import { canEditPermission } from "configs/constants";

const VehicleCategoryEdit = () => {
  const breadCrumbs = [
    { text: "SETTINGS" },
    { url: "/admin/settings/vehicle-categories", text: "VEHICLE CATEGORIES" },
    { text: "EDIT" }
  ];
  const vehicleCategory = useSelector(selectVehicleCategory);
  return (
    <div className="medium-modal">
      <SettingHeader breadCrumbs={breadCrumbs} hasButton={false} />
      <div className="admin-content form-content">
        <h2 className="title">Edit Vehicle Category</h2>
        <VehicleCategoryForm vehicleCategory={vehicleCategory} />
      </div>
    </div>
  );
};
export default withPermission(
  withFetchOne(VehicleCategoryEdit, {
    fetchData: doGetVehicleCategory
  }),
  canEditPermission
);
